export const getTimeFromDate = (date) => {
  const addLeadingZero = (value) => (value < 10 ? `0${value}` : value);
  return `${addLeadingZero(date.getHours())}:${addLeadingZero(
    date.getMinutes(),
  )}:${addLeadingZero(date.getSeconds())}`;
};

export const convertToDate = (dateStr: string) => {
  const [date, time = '00:00:00'] = dateStr.split(' ');
  const [year, month, day] = date.split('-').map((item) => Number(item));
  const [hour, mins, sec] = time.split(':').map((item) => Number(item));

  return new Date(year, month - 1, day, hour, mins, sec);
};
